import React, {useState} from "react";
import {
  Box,
  IconButton,
  Table, TableBody, TableCell, TableHead, TableRow,
  Tooltip,
  Typography
} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {IconPencil, IconPlus, IconTrash} from "@tabler/icons-react";
import {CreateVarModal} from "./CreateVarModal";
import {CreateVariableModal} from "../settings/CreateVariableModal";
import {NodeType} from "../../../../../model/ModelData";

export const VarsTab = ({node, onUpdate, project}) => {
  const {primary, secondary} = menuItemsInfo.vars;
  const [open, setOpen] = useState(false);
  const [selectedVar, setSelectedVar] = useState(null);

  return (
      <>
        <CreateVariableModal
            open={open}
            handleClose={() => {
              setOpen(false);
              setSelectedVar(null);
            }}
            project={project}
            editParam={selectedVar} isForm={!!node?.data?.form_id}
            onUpdateParams={(newParams) => {
              const newNode = {...node};
              newNode.data.params = newParams || [];
              onUpdate(newNode)
            }}
            params={node?.data?.params || []}
        />
        <Box sx={{borderBottom: 1, borderColor: "divider", pb: 0.5}}>
          <Typography fontWeight={700} sx={{pb: 1}}>{primary}</Typography>
          <Typography variant={"body2"} fontSize={13}>{secondary}</Typography>
        </Box>

        <Box sx={{ width: "100%", overflowX: "hidden" }}>
          <Table
              size="small"
              sx={{
                tableLayout: "fixed",
                width: "100%",
                "& .MuiTableCell-root": { py: 0.25, px: 0.5, boxSizing: "border-box" }
              }}
          >
            <colgroup>
              <col style={{ width: "44%" }} />
              <col style={{ width: "44%" }} />
              <col style={{ width: "36px" }} />
            </colgroup>
            <TableHead>
              <TableRow>
                <TableCell sx={{fontWeight: 600, fontSize: 12}}>From</TableCell>
                <TableCell sx={{fontWeight: 600, fontSize: 12}}>Target</TableCell>
                <TableCell sx={{fontWeight: 600, fontSize: 12, p: 0}}>
                  <Tooltip title={"Add new variable"}>
                    <IconButton size={"small"} onClick={() => setOpen(true)}>
                      <IconPlus size={16} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {node?.data?.params?.map((param, index) => (
                  <TableRow key={`${param.uid}-${index}`} hover>
                    <TableCell sx={{fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                      <Tooltip title={`(${param?.source_scope}) ${param?.source}`}>
                        <span>({param?.source_scope}) {param?.source}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                      <Tooltip title={`(${param?.target_scope}) ${param?.target}`}>
                        <span>({param?.target_scope}) {param?.target}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{p: 0}}>
                      <IconButton
                          size={"small"}
                          onClick={() => {
                            setSelectedVar(param);
                            setOpen(true)
                          }}
                      >
                        <IconPencil size={16}/>
                      </IconButton>
                    </TableCell>
                  </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </>
  )
}